import styled from 'styled-components';
import { colors } from 'bench-style-constants';

const Header = styled.div`
  background: ${colors.white};
  padding: 24px 32px;
  border-bottom: 1px solid ${colors.silt};
`;

export default Header;
